import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { Type } from '../Type/Type';

/**
 * Legal abstraction over Type.
 *
 * @deprecated
 */
export var Legal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedComponentWarning({
    component: 'Legal',
    migration: 'Use <Text size="x-small">.'
  });
  return /*#__PURE__*/React.createElement(Type, _extends({}, otherProps, {
    uppercase: undefined,
    color: undefined,
    size: 0,
    fontFamily: "gotham",
    ref: ref
  }), children);
});
Legal.displayName = 'Legal';